<template>
  <div
    class="container align-items-center justify-content-center d-flex vh-100"
  >
    <div
      class="w-100"
      style="max-width: 30rem"
    >
      <div
        class="d-flex align-items-center justify-content-center mb-5 gap-2 fs-2 fw-bold"
      >
        <Logo
          :fill="'#4089c9'"
          :height="'42px'"
          :width="'42px'"
        ></Logo>
        Portal
      </div>
      <div
        v-if="error"
        class="alert alert-danger"
      >
        {{ error }}
      </div>
      <div
        v-if="success"
        class="alert alert-success"
      >
        {{ success }}
      </div>
      <div class="card shadow-sm border-light-subtle">
        <div class="card-body p-5">
          <form
            action="#"
            @submit.prevent="submit"
          >
            <div class="mb-4">
              <label class="form-label">{{ $t("login.email") }}</label>
              <div class="input-group">
                <span class="input-group-text fw-bold">
                  <font-awesome-icon :icon="['far', 'envelope']" />
                </span>
                <input
                  id="email"
                  type="email"
                  class="form-control"
                  name="email"
                  value
                  required
                  autofocus
                  v-model="form.email"
                  :disabled="loading"
                />
              </div>
            </div>
            <div class="mb-4">
              <button
                type="submit"
                class="btn btn-primary w-100 text-white"
                :disabled="loading"
              >
                <span class="spinner-border spinner-border-sm me-2" aria-hidden="true" v-if="loading"></span>
                {{ $t("reset_password.send") }}
              </button>
            </div>
            <div class="text-center">
              <small>
                <router-link
                  class="link-underline link-underline-opacity-0 link-underline-opacity-100-hover"
                  :to="`/login`"
                >
                  {{ $t("login.login") }}
                </router-link>
              </small>
            </div>
          </form>
        </div>
      </div>
      <div class="d-flex justify-content-center mt-3">
        <Lang />
      </div>  
    </div>
  </div>
</template>

<script>
  import {functions} from "../plugins/firebase";
  import {httpsCallable} from "firebase/functions";
  import Logo from "../assets/Logo";
  import Lang from "./smallComponents/LangComponent";

  export default {
    name: "LoginComponent",
    components: {
      Logo,
      Lang,
    },
    data() {
      return {
        form: {
          email: "",
        },
        error: null,
        success: null,
        loading: false,
      };
    },
    methods: {
      submit() {
        this.loading = true;
        const resetPassword = httpsCallable(
          functions,
          "requestPasswordReset"
        );
        resetPassword({email: this.form.email, lang: this.$i18n.locale})
          .then(() => {
            this.form.email = "";
            this.success = this.$t("reset_password.success");
          })
          .catch((err) => {
            this.error = err.message;
          })
          .finally(() => {
            this.loading = false;
          });
      },
    },
  };
</script>
